import React, { useEffect } from "react";
import { useTitle } from "../provider/TitleProvider";

const About = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("About Fintree");
  }, []);

  return (
    <div className="auto-container">
      <div className="row clearfix">
        <p>
          <strong>
            More than 9 in 10 people want to own their home rather than renting but only 1 in 10 can afford it.
          </strong>
        </p>
        <p>Almost half of people with a mortgage are in struggling to with the repayment since the rate rises.</p>
        <p>
          Fintree’s mission is to ensure as many of those people who want to own home can afford it as soon as possible,
          without monthly repayments being too much of a burden.
        </p>
        <p>
          It takes on average more than a decade to save up a deposit. We can get you into your dream home much quicker.
          If rate rise have made your mortgage repayments skyrocket, Fintree is here to help.
        </p>
        <p>
          Property in Australia has appreciated at over 8% a year for over 6 decades. That’s more than a 120x increase
          in price.
        </p>
        <p>
          <strong>
            By sharing an investment in your home, there is enough gains for you and us to share that’s just a win-win
            for everyone. Fintree is designed so that you can buy as out as quickly as possible, we are just there to
            give you a boost when it helps the most.
          </strong>
        </p>
      </div>
    </div>
  );
};

About.propTypes = {};

export default About;
